'use es6';

export const allSelectors = {};
const allSelectorsContextRequire = require.context('../redux/selectors', true, /^.*.js$/);
allSelectorsContextRequire.keys().forEach(selectorPath => {
  const exportedSelectors = allSelectorsContextRequire(selectorPath);
  allSelectors[`CEUI/${selectorPath}`] = exportedSelectors;
});